import { useNavigate } from "react-router-dom";
import { AlertTriangle, Clock } from "lucide-react";
import { useSubscription } from "../../context/SubscriptionContext";
import "./SubscriptionBanner.css";

// A single persistent strip at the top of the app:
//   • blocked → red "renew" bar
//   • trial   → gold countdown bar
//   • active  → nothing
const SubscriptionBanner = () => {
  const navigate = useNavigate();
  const { loading, blocked, trial, daysLeft, isAdmin, hasAutopay } = useSubscription();

  if (loading || (!blocked && !trial)) return null;

  if (blocked) {
    return (
      <div className="sub-banner sub-banner--danger">
        <AlertTriangle size={16} />
        <span className="sub-banner__text">
          {isAdmin
            ? "Your subscription is inactive. Set up autopay to restore access for your team."
            : "Your subscription is inactive. Please ask your master to renew it."}
        </span>
        {isAdmin && (
          <button className="sub-banner__btn" onClick={() => navigate("/billing")}>
            Renew now
          </button>
        )}
      </div>
    );
  }

  // Trial
  const dayText = `${daysLeft} day${daysLeft === 1 ? "" : "s"}`;
  return (
    <div className="sub-banner sub-banner--trial">
      <Clock size={16} />
      <span className="sub-banner__text">
        Free trial — {dayText} left.
        {isAdmin && !hasAutopay && " Set up autopay so access continues after the trial."}
      </span>
      {isAdmin && !hasAutopay && (
        <button className="sub-banner__btn" onClick={() => navigate("/billing")}>
          Set up autopay
        </button>
      )}
    </div>
  );
};

export default SubscriptionBanner;
